import { ConditionSet } from '../types';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConditionSetSummaryProps {
  conditionSets?: ConditionSet[];
}

export default function ConditionSetSummary({ conditionSets }: ConditionSetSummaryProps) {
  const { t } = useTranslation();

  const shouldHideOperator = (index: number) => {
    if (!conditionSets || conditionSets.length === 0) return true;

    // no conditions configured
    if (conditionSets[index].conditions.length === 0) return true;

    // last condition set
    return index === conditionSets.length - 1;
  };

  return (
    <Box
      sx={{
        backgroundColor: '#eeeeee',
        width: '100%',
        minHeight: '5em',
        borderRadius: '5px',
        padding: '1em',
        boxSizing: 'border-box',
        fontFamily: 'monospace',
      }}
    >
      {conditionSets?.map((cs, i) => (
        <Box key={cs.id} sx={{ display: 'flex', flexDirection: 'column' }}>
          <ConditionSummary conditionSet={cs} />
          {!shouldHideOperator(i) && (
            <Box sx={{ textTransform: 'uppercase', marginBottom: 1, marginTop: 1 }}>{t('billableMaterial.or')}</Box>
          )}
        </Box>
      ))}
    </Box>
  );
}

function ConditionSummary({ conditionSet }: { conditionSet: ConditionSet }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ marginLeft: '1em' }}>
      {conditionSet.conditions.map((condition, i) => (
        <Box key={i} sx={{ display: 'flex', gap: '1em', marginBottom: 0.5 }}>
          <Box component='span'>{t(`billableMaterial.conditionTypes.${condition.type}`)} </Box>
          <Box component='span' fontWeight='bold'>
            {t(`billableMaterial.conditions.${condition.type}`, { ...condition })}
          </Box>
          {i < conditionSet.conditions.length - 1 && (
            <Box component='span' sx={{ textTransform: 'uppercase' }}>
              {t('billableMaterial.and')}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
